import { Category, Transaction } from 'types/finance';

export function exportTransactionsToCsv(
  transactions: Transaction[],
  categories: Category[]
): void {
  const categoryMap = new Map(categories.map((c) => [c.id, c.name]));
  const headers = ['Date', 'Type', 'Category', 'Amount', 'Description'];
  const rows = transactions.map((tx) => [
    tx.date,
    tx.type,
    categoryMap.get(tx.categoryId) ?? 'Unknown',
    tx.amount.toString(),
    `"${tx.description.replace(/"/g, '""')}"`,
  ]);

  const csv = [headers.join(','), ...rows.map((r) => r.join(','))].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `transactions-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
